/* eslint-disable jsx-a11y/anchor-has-content */
import { makeStyles } from '@mui/styles';
import Divider from 'apollo-react/components/Divider';
import IconButton from 'apollo-react/components/IconButton';
import Menu from 'apollo-react/components/Menu';
import MenuItem from 'apollo-react/components/MenuItem/MenuItem';
import Tooltip from 'apollo-react/components/Tooltip';
import Question from 'apollo-react-icons/Question';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setOpenHelpTopicsModal } from '../../actions/HelpTopicsActions';
import {
  fetchInstalledVersionsFromServer,
  openInstalledVersionsModal,
} from '../../actions/InstalledVersionsActions';
import { HELP, IQVIA, TECHNICAL_SUPPORT } from '../../constants/Urls';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { getIsRtlLanguage } from '../../selectors/AuthSelectors';
import { getUITA } from '../../utils/commonUtils';

const useStyles = makeStyles({
  iconButton: {
    borderRadius: 0,
    color: '#fff',
    fontSize: '1rem',
    marginLeft: '-0.75rem',
    padding: '0.5rem 1rem !important',
    height: '3.5rem !important',
    width: 'auto !important',
    '&:hover, &[aria-owns=helpmenu-appbar]': {
      backgroundColor: 'rgba(255, 255, 255, 0.24)',
      color: '#fff',
    },
  },
  divider: {
    margin: '0.5rem',
  },
  root: {
    paddingRight: '0.75rem',
  },
  list: {
    '& li': {
      padding: 0,
    },
    '& a, & span': {
      display: 'block',
      padding: '0.5rem 1rem',
      width: '100%',
    },
  },
});

const ExternalLink = (props) => <a target="_blank" rel="noopener noreferrer" {...props} />;

const UserDropdown = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const translateString = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const isRtlLanguage = useSelector(getIsRtlLanguage);

  useEffect(() => {
    dispatch(fetchInstalledVersionsFromServer());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const displayInstalledVersionsModal = () => {
    handleDropdownClose();
    dispatch(openInstalledVersionsModal());
  };

  const displayHelpTopicsModal = () => {
    handleDropdownClose();
    dispatch(setOpenHelpTopicsModal(true));
  };

  const handleDropdownOpen = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleDropdownClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={classes.root} ui-ta={getUITA('HelpMenuDropDown')}>
      <Tooltip title={translateString('Help')} placement="bottom">
        <IconButton
          aria-haspopup="true"
          aria-owns={anchorEl ? 'helpmenu-appbar' : null}
          aria-label={translateString('Help')}
          className={classes.iconButton}
          disableRipple
          onClick={handleDropdownOpen}
        >
          <Question style={{ width: 24, height: 24 }} />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{
          horizontal: 'right',
          vertical: 'bottom',
        }}
        classes={{ list: classes.list }}
        disableAutoFocusItem
        id="HelpDropDownContainer"
        onClose={handleDropdownClose}
        open={Boolean(anchorEl)}
        PaperProps={{
          square: true,
          style: isRtlLanguage
            ? {
                marginLeft: -100,
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0,
              }
            : {
                marginLeft: -3,
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0,
              },
        }}
      >
        <MenuItem onClick={handleDropdownClose}>
          <ExternalLink href={HELP}>{translateString('Help')}</ExternalLink>
        </MenuItem>

        <MenuItem onClick={displayHelpTopicsModal}>
          <span>{translateString('Help Topics')}</span>
        </MenuItem>

        <MenuItem onClick={handleDropdownClose}>
          <ExternalLink href={TECHNICAL_SUPPORT}>
            {translateString('Technical Support')}
          </ExternalLink>
        </MenuItem>

        <Divider className={classes.divider} />

        <MenuItem onClick={displayInstalledVersionsModal}>
          <span>{translateString('Installed Versions')}</span>
        </MenuItem>

        <Divider className={classes.divider} />

        <MenuItem onClick={handleDropdownClose}>
          <ExternalLink href={IQVIA}>{translateString('About IQVIA')}</ExternalLink>
        </MenuItem>
      </Menu>
    </div>
  );
};

export default UserDropdown;
